import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';

export const useSelectedItemName = ({ serviceId, serviceCollectionGuid }) => {
  return useSelector((state) => {
    // order matters here. If serviceCollectionGuid, prefer it
    if (serviceCollectionGuid !== undefined && serviceCollectionGuid !== null && serviceCollectionGuid !== '') {
      const serviceCollections = Global.selectSellerServiceCollections(state);
      const matchingServiceCollection = serviceCollections.find(
        (serviceCollection) => serviceCollection.serviceCollectionGuid === serviceCollectionGuid,
      );
      if (!matchingServiceCollection) {
        return undefined;
      }
      return matchingServiceCollection.name;
    }

    if (serviceId !== undefined) {
      const services = Global.selectSellerServices(state);
      const matchingService = services.find((service) => service.serviceId === serviceId);
      if (!matchingService) {
        return undefined;
      }
      return matchingService.name;
    }

    return undefined;
  });
};
